import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { SorteioService } from '../../../publico/sorteios';
import { PremioSorteioModel, SorteioConsumidorModel } from '../../../shared';
import { FiltroDetalheSorteioConsumidor } from '../../../shared/filter/filtro-detalhes-sorteio-consumidor';
import { BilheteConsumidorService } from '../shared';
import { LoginService } from '../shared/login.service';
import { ConsumidorModel } from './../shared/consumidor.model';
import { ConsumidorService } from './../shared/consumidor.service';
import { CidadaoLgpd } from '../consumidor-lgpd/cidadao-lgpd';

@Component({
  selector: 'app-consumidor-detalhe-sorteio',
  templateUrl: './consumidor-detalhe-sorteio.component.html',
  styleUrls: []
})
export class ConsumidorDetalheSorteioComponent implements OnInit {

  public sorteio: SorteioConsumidorModel;

  public premiosSorteio: Array<PremioSorteioModel>;
  public consumidor: ConsumidorModel;
  public exibirBilhetes = false;

  public MensagemImpedidoCidadao: string = '';

  public buttonsDisabled = false;

  constructor(
    private readonly router: ActivatedRoute,
    private readonly router2: Router,
    private readonly sorteioService: SorteioService,
    private readonly consumidorService: ConsumidorService,
    private readonly bilheteConsumidorService: BilheteConsumidorService,
    private readonly loginService: LoginService
  ) {}

  ngOnInit() {
    this.sorteio = new SorteioConsumidorModel();

    this.sorteioService.SorteioConsumidorModelSelected.subscribe((data: SorteioConsumidorModel) => {
      this.sorteio = data;
    });

    this.consumidor = this.consumidorService.getConsumidorModel();

    let filtro = new FiltroDetalheSorteioConsumidor(this.consumidor.consumidorId, this.router.snapshot.params['id']);
    this.sorteioService.detalharSorteioConsumidor(filtro);

    this.MensagemImpedidoCidadao = this.definirMensagemImpedimentoCidadao();
  }

  private definirMensagemImpedimentoCidadao() {

    if(!this.sorteio) return '';

    if(this.sorteio.participaSorteio == 1) return ''

    return 'Cidadão Impedido neste sorteio.'
  }

  public escolherData(sorteio: SorteioConsumidorModel) {
    // 3 - Realizado; 4 - Homologado
    if (sorteio.codSituacaoPremiacaoConsumidor === 3 || 
        sorteio.codSituacaoPremiacaoConsumidor === 4) {
      return sorteio.dataRealizacao;
    } else {
      return sorteio.dataPrevisao;
    }
  }

  public escolherTexto(sorteio: SorteioConsumidorModel): string {

    // 1 - Atual; 2 - A Realizar;  5 - Suspenso
    if (sorteio.codSituacaoPremiacaoConsumidor === 1 || 
        sorteio.codSituacaoPremiacaoConsumidor === 2 ||
        sorteio.codSituacaoPremiacaoConsumidor === 5) {
      return 'Data Prevista:';
    } else {
        return 'Realizado no dia:';
    }
  }

  public observacaoSuspenso(sorteio: SorteioConsumidorModel): string {
    if (sorteio.codSituacaoPremiacaoConsumidor === 5) {
      return ' (SUSPENSO)';
    } else {
        return ' ';
    }
  }

  public visualizarBilhetes() {
    this.bilheteConsumidorService.sorteio = this.sorteio;
    this.bilheteConsumidorService.consumidor = this.consumidor;
    this.exibirBilhetes = true;
  }

  public detalhesSorteio(id: number, acessoPublico: boolean = false): void {
    if (this.loginService.isLogged() && !acessoPublico) {
      this.router2.navigate([`/consumidor/detalhe_sorteio/${id}`]);
    } else {
      this.router2.navigate([`/sorteios/detalhe/${id}`]);
    }
  }

  public voltar() {
    this.router2.navigate([`/sorteios/`]);
  }

  public onVoltarBilhetesClicked(_exibirBilhetes: boolean): void {
    this.exibirBilhetes = _exibirBilhetes;
  }
}



// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-detalhe-sorteio/consumidor-detalhe-sorteio.component.ts